<template>
  <!-- Главен router outlet -->
  <router-view />
</template>

<script>
export default {
  name: "App",
};
</script>

<style>
:root {
  --mint-color: #0e6b5f;
  --mint-hover: #f4fbfa;
}

.q-btn {
  border-radius: 10px !important;
  font-weight: 600 !important;
  letter-spacing: 0.3px;
  min-height: 38px;
  transition: all 0.25s ease;
  color: var(--mint-color) !important;
}

/*  Исклучи темниот overlay што Quasar го додава */
.q-btn::before,
.q-btn:hover::before,
.q-btn:focus::before,
.q-btn:active::before {
  background: transparent !important;
  opacity: 0 !important;
  content: none !important;
}

/* Бело копче со зелена рамка — исто како менито */
.btn-clean {
  background-color: #ffffff !important;
  color: var(--mint-color) !important;
  border: 1.5px solid var(--mint-color) !important;
  box-shadow: none !important;
}
.btn-clean:hover,
.btn-clean:focus {
  background-color: var(
    --mint-hover
  ) !important; /* истиот ефект како во мени */
  color: var(--mint-color) !important;
  box-shadow: 0 2px 4px rgba(14, 107, 95, 0.1);
  transform: translateY(-1px);
}
.btn-clean:active {
  transform: scale(0.98);
  box-shadow: none !important;
}

/*  Зелени / Excel / Зачувај копчиња */
.btn-mint,
.q-btn[color="positive"],
.q-btn.bg-green {
  background-color: var(--mint-color) !important;
  color: #ffffff !important;
  border: none !important;
  box-shadow: none !important;
}
.btn-mint:hover,
.q-btn[color="positive"]:hover,
.q-btn.bg-green:hover {
  background-color: var(--mint-hover) !important; /* менито ефект */
  color: var(--mint-color) !important;
  border: 1.5px solid var(--mint-color) !important;
  box-shadow: 0 2px 4px rgba(14, 107, 95, 0.1);
  transform: translateY(-1px);
}

/* Ripple ефект – благ */
.q-ripple {
  opacity: 0.05 !important;
}

.q-field--outlined .q-field__control {
  border: 1.5px solid rgba(14, 107, 95, 0.4);
  border-radius: 10px !important;
  transition: border-color 0.25s ease, box-shadow 0.25s ease;
}
.q-field--outlined.q-field--focused .q-field__control {
  border-color: var(--mint-color);
  box-shadow: 0 0 0 3px rgba(14, 107, 95, 0.08);
}
.q-field--outlined:hover .q-field__control {
  border-color: rgba(14, 107, 95, 0.6);
}

::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}
::-webkit-scrollbar-thumb {
  background-color: rgba(14, 107, 95, 0.3);
  border-radius: 6px;
}
::-webkit-scrollbar-thumb:hover {
  background-color: rgba(14, 107, 95, 0.5);
}
::-webkit-scrollbar-track {
  background-color: #f0f0f0;
  border-radius: 6px;
}

a {
  color: var(--mint-color);
  text-decoration: none;
}
a:hover {
  text-decoration: underline;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
